//---- Dependencies ----//
import i18n from "../../i18n";

//---- Common ----//
import GetCookie from "./Functions/GetCookie";

export default () => {
    let pass_check = true;
    let headers = null;
    const domainName = window.location.hostname.startsWith('www.') ?
        window.location.hostname.replace('www.', '') :
        window.location.hostname;
    if (GetCookie("token") === "") {
        headers = {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Accept-Language": i18n.language,
            "x-cms-domain": domainName
        };
    } else {
        headers = {
            "Authorization": "Token " + GetCookie("token"),
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Accept-Language": i18n.language,
            "x-cms-domain": domainName
        };
    }
    return {
        pass_check, headers
    }
}